/*
 * CLZ Delivery Data v2
 * Origin: Sahibabad, Ghaziabad (UP)
 * BlueDart Express + Delhivery Air — Pan India coverage
 * ALL pincodes serviceable. No "not available" shown ever.
 *
 * Zones (transit days, BlueDart Express):
 * Zone 1 — 1 day  : Delhi NCR, Ghaziabad, Noida, Faridabad, Gurgaon, Meerut
 * Zone 2 — 2 days : UP, Rajasthan, Haryana, Punjab, HP, Uttarakhand, Chandigarh
 * Zone 3 — 3 days : Maharashtra, Gujarat, MP, WB, Bihar, Odisha, Jharkhand, Karnataka, TN, AP, Telangana
 * Zone 4 — 3 days : All remaining — Delhivery Air Express (NE, J&K, Kerala, far South, islands)
 *
 * Note: Zone 4 uses Delhivery Air, shown as "DELHIVERY AIR EXPRESS" badge
 * Max shown: 3 days. Never show 4+ days to customer.
 */
window.CLZ_PINCODE_DATA = (function(){
  var map = {};

  // ─── ZONE 1 — 1 DAY — BlueDart Express (Delhi NCR + satellite cities) ───
  var z1 = [
    // Delhi all
    110001,110002,110003,110004,110005,110006,110007,110008,110009,110010,
    110011,110012,110013,110014,110015,110016,110017,110018,110019,110020,
    110021,110022,110023,110024,110025,110026,110027,110028,110029,110030,
    110031,110032,110033,110034,110035,110036,110037,110038,110039,110040,
    110041,110042,110043,110044,110045,110046,110047,110048,110049,110050,
    110051,110052,110053,110054,110055,110056,110057,110058,110059,110060,
    110061,110062,110063,110064,110065,110066,110067,110068,110069,110070,
    110071,110072,110073,110074,110075,110076,110077,110078,110079,110080,
    110081,110082,110083,110084,110085,110086,110087,110088,110089,110090,
    110091,110092,110093,110094,110095,110096,110097,
    // Noida / Greater Noida
    201301,201302,201303,201304,201305,201306,201307,201308,201309,201310,
    201311,201312,201313,201314,201315,201316,201317,201318,201319,201320,
    // Ghaziabad / Sahibabad
    201001,201002,201003,201004,201005,201006,201007,201008,201009,201010,
    201011,201012,201013,201014,201015,201016,201017,201018,201019,201020,
    201102,201103,201204,201205,201206,201207,201208,201209,201210,
    // Faridabad
    121001,121002,121003,121004,121005,121006,121007,121008,121009,121010,
    121012,121013,121014,121015,121101,121102,
    // Gurugram / Gurgaon
    122001,122002,122003,122004,122005,122006,122007,122008,122009,122010,
    122011,122012,122013,122015,122016,122017,122018,122051,122052,
    // Meerut
    250001,250002,250003,250004,250005,250101,250103,250110,250205,
    // Sonipat
    131001,131021,131023,131024,131029,131039,131101,131103,
    // Bahadurgarh / Jhajjar
    124507,124508,124001,124021,
    // Ghaziabad extended / Loni
    201102,201103,201011,201012
  ];

  // ─── ZONE 2 — 2 DAYS — BlueDart Express ───
  var z2 = [
    // Lucknow
    226001,226002,226003,226004,226005,226006,226007,226008,226009,226010,
    226011,226012,226013,226014,226015,226016,226017,226018,226019,226020,
    226021,226022,226023,226024,226025,226026,226028,226029,226030,
    // Agra
    282001,282002,282003,282004,282005,282006,282007,282008,282009,282010,
    // Kanpur
    208001,208002,208003,208004,208005,208006,208007,208008,208009,208010,
    208011,208012,208013,208014,208015,208016,208017,208018,208019,208020,
    208021,208022,208023,208024,208025,208026,208027,
    // Varanasi
    221001,221002,221003,221004,221005,221006,221007,221008,221009,221010,
    // Prayagraj / Allahabad
    211001,211002,211003,211004,211005,211006,211007,211008,211009,211010,
    // Mathura / Vrindavan
    281001,281003,281004,281006,281121,281122,281123,
    // Aligarh
    202001,202002,202003,202004,202005,202006,202007,202008,
    // Bareilly
    243001,243002,243003,243004,243005,243006,
    // Moradabad
    244001,244002,244003,244004,244005,
    // Jaipur
    302001,302002,302003,302004,302005,302006,302007,302008,302009,302010,
    302011,302012,302013,302014,302015,302016,302017,302018,302019,302020,
    302021,302022,302023,302024,302025,302026,302027,302028,302029,302030,
    // Jodhpur
    342001,342002,342003,342004,342005,342006,342007,342008,342009,342010,
    342011,342012,342013,342014,342015,
    // Udaipur
    313001,313002,313003,313004,313011,313015,
    // Kota
    324001,324002,324003,324004,324005,324006,324007,324008,324009,324010,
    // Chandigarh / Punjab
    160001,160002,160003,160004,160010,160011,160012,160014,160015,160016,
    160017,160018,160019,160020,160022,160023,160024,160025,160036,160041,
    160043,160044,160047,160055,160059,160061,160062,160063,160064,160065,
    // Amritsar
    143001,143002,143003,143004,143005,143006,143007,143008,143009,143010,
    // Ludhiana
    141001,141002,141003,141004,141005,141006,141007,141008,141009,141010,
    // Jalandhar
    144001,144002,144003,144004,144005,144006,144007,144008,144009,144010,
    // Patiala
    147001,147002,147003,147004,147005,
    // Ambala
    133001,133002,133003,133004,133005,133006,133021,133101,133102,
    // Hisar
    125001,125002,125003,125004,125005,125006,125007,125008,
    // Rohtak
    124001,124002,124003,124004,124005,
    // Dehradun
    248001,248002,248003,248004,248005,248006,248007,248008,248009,248010,
    // Haridwar / Rishikesh
    249401,249402,249411,249201,249202,
    // Shimla
    171001,171002,171003,171004,171005,171006,171007,171008,
    // Dharamsala
    176215,176216,176057,
    // Agra
    282001,282002,282003,282004,282005
  ];

  // ─── ZONE 3 — 3 DAYS — BlueDart Express ───
  var z3 = [
    // Mumbai
    400001,400002,400003,400004,400005,400006,400007,400008,400009,400010,
    400011,400012,400013,400014,400015,400016,400017,400018,400019,400020,
    400021,400022,400023,400024,400025,400026,400027,400028,400029,400030,
    400031,400032,400033,400034,400035,400036,400037,400038,400039,400040,
    400041,400042,400043,400044,400045,400046,400047,400048,400049,400050,
    400051,400052,400053,400054,400055,400056,400057,400058,400059,400060,
    400061,400062,400063,400064,400065,400066,400067,400068,400069,400070,
    400071,400072,400073,400074,400075,400076,400077,400078,400079,400080,
    400081,400082,400083,400084,400085,400086,400087,400088,400089,400090,
    400091,400092,400093,400094,400095,400096,400097,400098,400099,400100,
    // Navi Mumbai / Thane
    400701,400703,400705,400706,400707,400708,400709,400710,
    401101,401102,401103,401104,401105,401106,401107,
    // Pune
    411001,411002,411003,411004,411005,411006,411007,411008,411009,411010,
    411011,411012,411013,411014,411015,411016,411017,411018,411019,411020,
    411021,411022,411023,411024,411025,411026,411027,411028,411029,411030,
    411031,411032,411033,411034,411035,411036,411037,411038,411039,411040,
    411041,411042,411043,411044,411045,411046,411047,411048,411057,411060,
    // Nagpur
    440001,440002,440003,440004,440005,440006,440007,440008,440009,440010,
    440011,440012,440013,440014,440015,440016,440017,440018,440019,440020,
    // Nashik
    422001,422002,422003,422004,422005,422006,422007,422008,422009,422010,
    // Ahmedabad
    380001,380002,380003,380004,380005,380006,380007,380008,380009,380010,
    380011,380012,380013,380014,380015,380016,380017,380018,380019,380020,
    380021,380022,380023,380024,380025,380026,380027,380028,380051,380052,
    380054,380055,380058,380059,380060,380061,380063,380065,
    // Surat
    395001,395002,395003,395004,395005,395006,395007,395008,395009,395010,
    // Vadodara
    390001,390002,390003,390004,390005,390006,390007,390008,390009,390010,
    390011,390012,390013,390014,390015,390016,390017,390018,390019,390020,
    // Rajkot
    360001,360002,360003,360004,360005,360006,360007,
    // Bhopal
    462001,462002,462003,462004,462010,462011,462016,462021,462022,462023,
    462024,462026,462027,462030,462031,462033,462036,462037,462038,462039,
    // Indore
    452001,452002,452003,452004,452005,452006,452007,452008,452009,452010,
    452011,452012,452013,452014,452015,452016,452017,452018,452019,452020,
    // Jabalpur
    482001,482002,482003,482004,482005,482006,482007,482008,482009,
    // Kolkata
    700001,700002,700003,700004,700005,700006,700007,700008,700009,700010,
    700011,700012,700013,700014,700015,700016,700017,700018,700019,700020,
    700021,700022,700023,700024,700025,700026,700027,700028,700029,700030,
    700031,700032,700033,700034,700035,700036,700037,700038,700039,700040,
    700041,700042,700043,700044,700045,700046,700047,700048,700049,700050,
    700051,700052,700053,700054,700055,700056,700057,700058,700059,700060,
    700061,700062,700063,700064,700065,700066,700067,700068,700069,700070,
    700071,700072,700073,700074,700075,700076,700077,700078,700079,700080,
    700081,700082,700083,700084,700085,700086,700087,700088,700089,700090,
    700091,700092,700093,700094,700095,700096,700097,700098,700099,700100,
    700101,700102,700103,700104,700105,700106,700107,700108,700109,700110,
    // Patna
    800001,800002,800003,800004,800005,800006,800007,800008,800009,800010,
    800011,800012,800013,800014,800015,800016,800017,800018,800019,800020,
    // Bhubaneswar / Cuttack
    751001,751002,751003,751004,751005,751006,751007,751008,751009,751010,
    751011,751012,751013,751014,751015,751016,751017,751018,751019,751020,
    753001,753002,753003,753004,753005,753006,753007,753008,753009,753010,
    // Ranchi
    834001,834002,834003,834004,834005,834006,834007,834008,834009,834010,
    // Bangalore
    560001,560002,560003,560004,560005,560006,560007,560008,560009,560010,
    560011,560012,560013,560014,560015,560016,560017,560018,560019,560020,
    560021,560022,560023,560024,560025,560026,560027,560028,560029,560030,
    560031,560032,560033,560034,560035,560036,560037,560038,560039,560040,
    560041,560042,560043,560044,560045,560046,560047,560048,560049,560050,
    560051,560052,560053,560054,560055,560056,560057,560058,560059,560060,
    560061,560062,560063,560064,560065,560066,560067,560068,560069,560070,
    560071,560072,560073,560074,560075,560076,560077,560078,560079,560080,
    560081,560082,560083,560084,560085,560086,560087,560088,560089,560090,
    560091,560092,560093,560094,560095,560096,560097,560098,560099,560100,
    // Chennai
    600001,600002,600003,600004,600005,600006,600007,600008,600009,600010,
    600011,600012,600013,600014,600015,600016,600017,600018,600019,600020,
    600021,600022,600023,600024,600025,600026,600027,600028,600029,600030,
    600031,600032,600033,600034,600035,600036,600037,600038,600039,600040,
    600041,600042,600043,600044,600045,600046,600047,600048,600049,600050,
    600051,600052,600053,600054,600055,600056,600057,600058,600059,600060,
    600061,600062,600063,600064,600065,600066,600067,600068,600069,600070,
    600071,600072,600073,600074,600075,600076,600077,600078,600079,600080,
    600081,600082,600083,600084,600085,600086,600087,600088,600089,600090,
    600091,600092,600093,600094,600095,600096,600097,600098,600099,600100,
    // Hyderabad
    500001,500002,500003,500004,500005,500006,500007,500008,500009,500010,
    500011,500012,500013,500014,500015,500016,500017,500018,500019,500020,
    500021,500022,500023,500024,500025,500026,500027,500028,500029,500030,
    500031,500032,500033,500034,500035,500036,500037,500038,500039,500040,
    500041,500042,500043,500044,500045,500046,500047,500048,500049,500050,
    500051,500052,500053,500054,500055,500056,500057,500058,500059,500060,
    500061,500062,500063,500064,500065,500066,500067,500068,500069,500070,
    500071,500072,500073,500074,500075,500076,500077,500078,500079,500080,
    500081,500082,500083,500084,500085,500086,500087,500088,500089,500090,
    // Coimbatore
    641001,641002,641003,641004,641005,641006,641007,641008,641009,641010,
    641011,641012,641013,641014,641015,641016,641017,641018,641019,641020,
    // Kochi
    682001,682002,682003,682004,682005,682006,682007,682008,682009,682010,
    682011,682012,682013,682014,682015,682016,682017,682018,682019,682020,
    // Thiruvananthapuram
    695001,695002,695003,695004,695005,695006,695007,695008,695009,695010,
    695011,695012,695013,695014,695015,695016,695017,695018,695019,695020,
    // Visakhapatnam
    530001,530002,530003,530004,530005,530006,530007,530008,530009,530010,
    530011,530012,530013,530014,530015,530016,530017,530018,530019,530020,
    // Guwahati
    781001,781002,781003,781004,781005,781006,781007,781008,781009,781010,
    // Chandigarh extended
    160101,160102,160103,
    // Ahmedabad extended
    382001,382002,382007,382010,382016,382020,382021,382022,382023,382024,
    382025,382026,382027,382028,382029,382030,382042,382043,382044
  ];

  z1.forEach(function(p){ map[p] = {days:1, carrier:'bluedart'}; });
  z2.forEach(function(p){ map[p] = {days:2, carrier:'bluedart'}; });
  z3.forEach(function(p){ map[p] = {days:3, carrier:'bluedart'}; });

  return map;
})();

/*
 * Lookup function used by clz-pincode-checker.liquid
 * Returns {days, carrier} for known pincodes
 * Returns {days:3, carrier:'delhivery'} for ALL others (pan-india fallback)
 */
window.CLZ_PIN_LOOKUP = function(pin){
  var p = parseInt(pin, 10);
  if(window.CLZ_PINCODE_DATA && window.CLZ_PINCODE_DATA[p]){
    return window.CLZ_PINCODE_DATA[p];
  }
  // Delhivery Air Express fallback — pan India, max 3 days
  return {days:3, carrier:'delhivery'};
};
